import { Breadcrumb, Button, Dialog, Flex, Heading, Text } from '@applyboard/crystal-ui';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IntakeCreateForm } from '../components';
import { IntakeManagementPageInitialProps } from '~/data';
import { BreadcrumbItem } from '~/utils';

type DesktopLayoutProps = Readonly<{
  initialProps: IntakeManagementPageInitialProps;
}>;

export function DesktopLayout({ initialProps }: DesktopLayoutProps) {
  const navigate = useNavigate();
  const [showDiscardModal, setShowDiscardModal] = useState(false);

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      href: '/intake-management',
      label: 'Intake Management',
    },
    {
      label: 'Add New Intake',
    },
  ] as BreadcrumbItem[];

  const handleCancel = () => {
    setShowDiscardModal(true);
  };

  const handleDiscard = () => {
    setShowDiscardModal(false);
    navigate('/intake-management');
  };

  const handleCloseModal = () => {
    setShowDiscardModal(false);
  };

  return (
    <Flex p={10} gap={8} direction="column">
      <Flex direction="column" gap={4}>
        <Breadcrumb items={breadcrumbItems} />
        <Flex justify="between" align="center">
          <Flex direction="column" gap={2}>
            <Heading contrast="high" level={1} variant="titleL">
              Add new intake
            </Heading>
            <Text variant="bodyM" contrast="mid">
              Please provide intake details below
            </Text>
          </Flex>
          <Flex gap={4}>
            <Button emphasis="outlined" onClick={handleCancel}>
              Cancel
            </Button>
            <Button intent="primary" type="submit" form="intake-create-form">
              Save
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <IntakeCreateForm initialProps={initialProps} />

      <Dialog open={showDiscardModal} onOpenChange={handleCloseModal} size="md">
        <Dialog.Heading>Discard Changes?</Dialog.Heading>
        <Dialog.Content>
          <Text variant="bodyM">
            You have unsaved changes. <br /> Are you sure you want to discard them?
          </Text>
        </Dialog.Content>
        <Dialog.Actions>
          <Button width="fill" intent="secondary" emphasis="highlighted" onClick={handleCloseModal}>
            Back to editing
          </Button>
          <Button width="fill" intent="negative" onClick={handleDiscard}>
            Discard
          </Button>
        </Dialog.Actions>
      </Dialog>
    </Flex>
  );
}
